var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1938 2.81289C11.2204 0.846224 8.02042 0.846224 6.06042 2.81289C4.68042 4.17956 4.26709 6.14622 4.80042 7.87956L1.66709 11.0129C1.44709 11.2396 1.29376 11.6862 1.34042 12.0062L1.54042 13.4596C1.61376 13.9396 2.06042 14.3929 2.54042 14.4596L3.99376 14.6596C4.31376 14.7062 4.76042 14.5596 4.98709 14.3262L5.53376 13.7796C5.66709 13.6529 5.66709 13.4396 5.53376 13.3062L4.24042 12.0129C4.04709 11.8196 4.04709 11.4996 4.24042 11.3062C4.43376 11.1129 4.75376 11.1129 4.94709 11.3062L6.24709 12.6062C6.37376 12.7329 6.58709 12.7329 6.71376 12.6062L8.12709 11.1996C9.85376 11.7396 11.8204 11.3196 13.1938 9.95289C15.1604 7.98622 15.1604 4.77956 13.1938 2.81289ZM9.66709 7.99956C8.74709 7.99956 8.00042 7.25289 8.00042 6.33289C8.00042 5.41289 8.74709 4.66622 9.66709 4.66622C10.5871 4.66622 11.3338 5.41289 11.3338 6.33289C11.3338 7.25289 10.5871 7.99956 9.66709 7.99956Z",
    fill: "#9091A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKey);
export default __webpack_public_path__ + "static/media/ic-key.58eace49d7f10473b33c3244aee2162c.svg";
export { ForwardRef as ReactComponent };